export default __webpack_public_path__ + "static/media/Side.a9dd88f4.png";